import { ReactComponent as DocumentIcon } from "@assets/icons/document.svg";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import BottomBar from "@components/BottomBars/BottomBar";
import BottomBarDesktop from "@components/BottomBars/BottomBarDesktop";
import CardInformation from "@components/Cards/CardInformation";
import HeaderProgress from "@components/Progress/HeaderProgress";
import {
  useCurrentUserMutation,
  usePensionApplicationSteps,
} from "@utils/hooks";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type CompletePRSAFormProps = {};

const CompletePRSAForm: React.FC<CompletePRSAFormProps> = () => {
  const navigate = useNavigate();
  const { currentStep, totalSteps } = usePensionApplicationSteps();
  const { mutate, isSuccess, isLoading } = useCurrentUserMutation();

  const handleReviewPrsa = () => {
    // send to zurich to create mail to user

    mutate({
      process_final_pension_application: true,
    });
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      navigate("zurich-provider");
    }
  }, [isLoading, isSuccess, navigate]);

  return (
    <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[880px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
        <HeaderProgress
          currentStep={currentStep}
          totalSteps={totalSteps}
          onlyStep
          closeButtonEvent={() => navigate("/pension-application")}
        />

        <div className="flex pb-[86px] md:pb-[36px] items-start flex-col md:flex-row md:items-stretch">
          <div className="flex-1">
            <div className="pl-0 py-0 pr-0 md:pl-8 md:py-6 md:pr-6 flex flex-col gap-y-2 md:gap-y-6">
              <div className="p-4 flex flex-col gap-y-4 md:gap-y-6">
                <div className="flex items-center isolate">
                  <div className="w-[60px] h-[60px] bg-pn_gray-lush flex items-center justify-center rounded-full">
                    <DocumentIcon className="w-8 h-8 [&>path]:stroke-pn_white" />
                  </div>
                  <div className="w-[60px] h-[60px] -z-10 -translate-x-4 bg-[#F4E34E] flex items-center justify-center rounded-full">
                    <PennyIcon className="w-6 h-[27px]" />
                  </div>
                </div>

                <div className="flex flex-col gap-y-2">
                  <span className="text-pn-large-title text-pn_gray-950">
                    Review PSRA Form
                  </span>
                  <span className="text-pn-body-large-regular text-pn_gray-600">
                    The PSRA form will help Penny get a complete overview of
                    your current status as well as sending you the right info.
                    You will be redirected to Zurich system where you will add
                    this info.
                  </span>
                </div>
              </div>

              <div className="px-3">
                <CardInformation
                  variant="info"
                  description={
                    <div className="text-pn-callout-regular">
                      Penny and Zurich work together to provide Penny's clients
                      with the best pensions.{" "}
                    </div>
                  }
                />
              </div>
            </div>
          </div>

          <div className="flex-1"></div>
        </div>

        <div className="hidden md:block">
          <BottomBarDesktop
            disableNext={isLoading}
            disableBack={isLoading}
            onBack={() => navigate(-1)}
            labelNext="Review Now"
            labelBack="Back"
            insideCard
            message="Your information is always secure with Penny"
            onNext={handleReviewPrsa}
          />
        </div>

        <div className="block md:hidden">
          <BottomBar
            layout="side_by_side"
            labelBack="Back"
            disabledNextBtn={isLoading}
            disabledBackBtn={isLoading}
            onBack={() => navigate(-1)}
            labelNext="Review Now"
            onNext={handleReviewPrsa}
          />
        </div>
      </div>
    </section>
  );
};
export default CompletePRSAForm;
